// components/Profile.js - Updated with enhanced Agent/User support
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Alert, Row, Col } from "react-bootstrap";
import { AuthContext } from "../../../Context/AuthContext";
import WalletBalance from "./WalletBalance";

const Profile = () => {
  const {
    user,
    getUserFullName,
    getUserInitials,
    getUserMobile,
    getUserEmail,
    getAgentInfo,
  } = useContext(AuthContext);

  const navigate = useNavigate();
  const agentInfo = getAgentInfo();

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // Determine user type for display
  const getUserType = () => {
    if (!user) return "user";
    return user.role === "agent" ||
      user.userType === "agent" ||
      user.type === "agent"
      ? "agent"
      : "user";
  };

  const userType = getUserType();
  const isAgent = userType === "agent";

  // Get appropriate greeting based on user type
  const getGreeting = () => {
    return isAgent ? "Agent Dashboard" : "Your Profile";
  };

  if (!user) {
    return (
      <div className="bg-white rounded-lg shadow p-6 text-center">
        <div
          className="w-20 h-20 mx-auto rounded-full bg-gray-300 flex items-center justify-content-center text-gray-500 text-2xl font-bold mb-4"
          style={{ width: "80px", height: "80px", fontSize: "2rem" }}
        >
          ?
        </div>
        <h2 className="text-2xl font-bold mb-4 text-gray-800">Please Login</h2>
        <p className="text-gray-600 mb-4">
          You need to login to view your profile.
        </p>
        <Button variant="primary" onClick={() => navigate("/")}>
          Go to Login
        </Button>
      </div>
    );
  }

  return (
    <div className="">
      {/* Wallet Balance Section - Top Priority */}
      <Row>
        <Col lg={12}>
          <WalletBalance className="mb-4" />
        </Col>
      </Row>

      {/* Profile Information */}
      <div className="bg-white rounded-lg shadow-sm border">
        {/* Success/Error Messages */}
        {message && (
          <Alert variant="success" className="m-4 mb-0">
            {message}
          </Alert>
        )}
        {error && (
          <Alert variant="danger" className="m-4 mb-0">
            {error}
          </Alert>
        )}

        <div className="p-4">
          <Row>
            {/* Profile Header - Col 4 */}
            <Col lg={4} className="text-center mb-4 mb-lg-0 pt-5">
              <div
                className="mx-auto rounded-circle d-flex align-items-center justify-content-center text-white text-3xl font-bold mb-3 shadow-lg bg-brand-600"
                style={{
                  width: "120px",
                  height: "120px",
                  fontSize: "2.2rem",
                }}
              >
                {getUserInitials()}
              </div>
              <h3 className="text-xl font-bold mb-2">{getUserFullName()}</h3>
            </Col>

            {/* Profile Information - Col 8 */}
            <Col lg={8}>
              <div className="row g-3">
                <div className="col-12">
                  <label className="form-label text-muted small fw-bold">
                    Full Name
                  </label>
                  <div className="p-3 bg-light rounded border">
                    <div className="d-flex align-items-center">
                      {/* <span className="text-primary me-2">👤</span> */}
                      <span className="fw-medium">{getUserFullName()}</span>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <label className="form-label text-muted small fw-bold">
                    Mobile Number
                  </label>
                  <div className="p-3 bg-light rounded border">
                    <div className="d-flex align-items-center">
                      {/* <span className="text-success me-2">📱</span> */}
                      <span>{getUserMobile()}</span>
                    </div>
                  </div>
                </div>

                {/* email */}
                {isAgent && agentInfo && (
                  <>
                    <div className="col-12">
                      <label className="form-label text-muted small fw-bold">
                        E-Mail
                      </label>
                      <div className="p-3 bg-light rounded border">
                        <div className="d-flex align-items-center">
                          {/* <span className="text-success me-2">📱</span> */}
                          <span>{getUserEmail()}</span>
                        </div>
                      </div>
                    </div>

                    {/* agent info */}
                    <div className="col-12">
                      <label className="form-label text-muted small fw-bold">
                        Agent ID
                      </label>
                      <div className="p-3 bg-light rounded border">
                        <div className="d-flex align-items-center">
                          {/* <span className="text-success me-2">📱</span> */}
                          <span>{agentInfo.agentId || "N/A"}</span>
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <label className="form-label text-muted small fw-bold">
                        Business Type
                      </label>
                      <div className="p-3 bg-light rounded border">
                        <div className="d-flex align-items-center">
                          {/* <span className="text-success me-2">📱</span> */}
                          <span>{agentInfo.businessType || "N/A"}</span>
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <label className="form-label text-muted small fw-bold">
                        Business Name
                      </label>
                      <div className="p-3 bg-light rounded border">
                        <div className="d-flex align-items-center">
                          {/* <span className="text-success me-2">📱</span> */}
                          <span>{agentInfo.businessName || "N/A"}</span>
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <label className="form-label text-muted small fw-bold">
                        City
                      </label>
                      <div className="p-3 bg-light rounded border">
                        <div className="d-flex align-items-center">
                          {/* <span className="text-success me-2">📱</span> */}
                          <span>{agentInfo.city || "N/A"}</span>
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-12">
                      <label className="form-label text-muted small fw-bold">
                        Commission
                      </label>
                      <div className="p-3 bg-light rounded border">
                        <div className="d-flex align-items-center">
                          {/* <span className="text-success me-2">📱</span> */}
                    {/* <span>{agentInfo.commission || "N/A"}%</span>
                        </div>
                      </div>
                    </div> */}

                    <div className="col-12">
                      <label className="form-label text-muted small fw-bold">
                        Account Status
                      </label>
                      <div className="p-3 bg-light rounded border">
                        <div className="d-flex align-items-center">
                          <span
                            className={`fw-medium ${
                              agentInfo.isActive ? "" : ""
                            }`}
                          >
                            {agentInfo.status
                              ? agentInfo.status.toUpperCase()
                              : "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <label className="form-label text-muted small fw-bold">
                        Registration Date
                      </label>
                      <div className="p-3 bg-light rounded border">
                        <div className="d-flex align-items-center">
                          {/* <span className="text-info me-2"></span> */}
                          <span>
                            {agentInfo.registrationDate
                              ? new Date(
                                  agentInfo.registrationDate
                                ).toLocaleDateString("en-IN", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                })
                              : "N/A"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Profile;
